import React from 'react';
import { FaPlus, FaPlusCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function BtnAdd({ to }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        navigate(`${to}`)
      }}
      className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
    >
      <FaPlusCircle />
      Crear nuevo
    </button>
  );
}
